/**
 * shareParam  传感器国际化
 * date：2022 05 18
 */
 export default {
    sensor:{
        temp:'Temperature',
        hum:'Relative Humidity',
        volt:'Voltage',
        rssi:'RSSI',
        lqi:'LQI',
        gas: 'Gas',
        magnetism: 'Door Sensor',
    }
}